import type { ReactNode } from 'react'
import type { ListShellProperty } from '@/core/components/list/ListShell'

export type TextOption = { key: string; label: string }

export type SortConfig<T> = {
  key: string
  label: string
  accessor: (item: T) => string | number
}

export type FilterCategory<T> = {
  id: string
  label: string
  catalog: (items: T[]) => TextOption[]
  accessor: (item: T) => string | readonly string[]
}

export type ViewPipelineConfig<T> = {

  rowKey: (item: T) => string

  groupBy?: (item: T) => string
  sortKeys?: SortConfig<T>[]

  searchFields?: (item: T) => (string | null | undefined)[]
  filterCategories?: FilterCategory<T>[]

  extraFilter?: (items: T[], filterState: unknown) => T[]

  excludedFor?: (filterState: unknown) => Record<string, string[]>
}

export function supportsBoardView<T>(config: ViewPipelineConfig<T>): boolean {
  return config.groupBy !== undefined
}

export type ViewConfig<T> = ViewPipelineConfig<T> & {

  title: (item: T) => ReactNode
  properties?: ListShellProperty<T>[]

  cards?: boolean
  emptyText?: string
}

export type BoardColumnConfig<T> = {
  id: string
  title: string

  actionObject?: string
  actionVerb?: string
  actionIcon?: string
  clickable?: boolean
  headerAction?: string
  headerDroppable?: boolean

  headerAccept?: string

  headerBusyLabel?: string

  headerDisabledHint?: (rows: readonly T[]) => string | null

  cardAction: (item: T) => string

  cardTone?: (item: T) => CardTone | undefined
}

export type CardTone = 'warning' | 'danger'

export type CardMark = { tone: CardTone; text: string; busy?: boolean }

export type BoardViewConfig<T> = ViewPipelineConfig<T> & {

  columns: BoardColumnConfig<T>[]

  renderCard: (item: T, col: BoardColumnConfig<T>) => ReactNode
}
